export const tourCarousel = (req)=>{
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        // body: JSON.stringify(req)
    };
    return fetch('/shared/api/tourCarousel', requestOptions).then((response)=>response.json())
}